<script>
  import EmailSignupForm from "$lib/contentTypes/EmailSignupForm.svelte";
  import FormField from "./FormField.svelte";
  import { setContext } from "svelte";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { writable } from "svelte/store";
  import { newsletterKeys } from "$lib/utilities/formFields";

  export let data;

  let newsletterOptions = data.fields.optionsToInclude.map((x) => newsletterKeys[x]);
  /* Initialize the store to have a key representing each option and a value
    representing whether it's been selected. */
  let newsletterStore = {};
  newsletterOptions.forEach((option) => {
    newsletterStore[option.fieldProps.name] = false;
  });
  let selectedNewsletters = writable(newsletterStore);

  const props = {
    data: data.fields.emailSignUpForm,
    buttonVariant: "primary",
    noCampaignErrorMessage: data.fields.errorMsgNoneSelected
  };

  function handleChange(ev) {
    const { detail } = ev;

    if (detail.name === "newsletters-select-all") {
      // Select or de-select all options.
      selectedNewsletters.update((state) => {
        Object.keys($selectedNewsletters).forEach((id) => {
          state[id] = document.getElementById("newsletters-select-all").checked;
        });
        return state;
      });
    } else {
      selectedNewsletters.update((state) => {
        // If select-all is checked and we unselect one option, also unselect select-all option.
        if (!detail.value && $selectedNewsletters["newsletters-select-all"]) {
          state["newsletters-select-all"] = detail.value;
        }
        state[detail.name] = detail.value;
        return state;
      });
    }
  }
  $: setContext("selectedNewsletters", selectedNewsletters);
</script>

<div aria-live="polite" class="max-w-806 mx-auto">
  <div class="flex flex-col md:flex-row gap-32 md:gap-24" class:md:flex-row={false}>
    {#each newsletterOptions as field}
      <div class={`flex-row md:flex-col ${field.fieldClass} mt-40`}>
        <FormField
          fieldType={field.fieldType}
          fieldProps={{
            ...field.fieldProps,
            defaultValue: $selectedNewsletters[field.fieldProps.name]
          }}
          on:clear={field.fieldProps.handleClear}
          on:change={handleChange}
        />
      </div>
    {/each}
  </div>
  <div class="mt-40">
    <EmailSignupForm {...props} />
  </div>
</div>
